import React from "react";

export const CartIcon = () => {
  return (
    <svg
      width="31"
      height="26"
      viewBox="0 0 31 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 8.6875L5.62945 23.9992H25.5914L29.2208 8.6875H2Z"
        stroke="white"
        stroke-width="2.2"
      />
      <path
        d="M10.5039 12.9091V6.10391C10.5039 3.2851 12.789 1 15.6078 1V1C18.4266 1 20.7117 3.2851 20.7117 6.10391V12.9091"
        stroke="white"
        stroke-width="2"
      />
    </svg>
  );
};
